import "dayjs/locale/fr";
import {frFR as materialFrFR} from "@mui/material/locale";
import {frFR as dataGridFrFR} from "@mui/x-data-grid/locales";
import {frFR as datePickersFrFR} from "@mui/x-date-pickers/locales";
import antdFrFR from "antd/locale/fr_FR";
import type {Locale as AntdLocale} from "antd/es/locale";

// Ce que les bibliothèques tierces traduisent elles-mêmes : les libellés de MUI (pagination,
// DataGrid, sélecteurs de date), ceux d'antd et les noms de mois ou de jours de dayjs. Nos propres
// libellés vivent dans `locales/<langue>/`. Une langue s'ajoute donc avec son dossier de
// traductions et sa ligne ici.
type LanguageSettings = {
  dayjs: string;
  mui: object[];
  antd: AntdLocale;
};

export const LANGUAGES = {
  fr: {dayjs: "fr", mui: [materialFrFR, dataGridFrFR, datePickersFrFR], antd: antdFrFR},
} satisfies Record<string, LanguageSettings>;

export type Language = keyof typeof LANGUAGES;

export const DEFAULT_LANGUAGE: Language = "fr";

export const languageSettings = (language: string | undefined): LanguageSettings =>
  LANGUAGES[language as Language] ?? LANGUAGES[DEFAULT_LANGUAGE];
